import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Badge } from 'primereact/badge';
import { Divider } from 'primereact/divider';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Skeleton } from 'primereact/skeleton';

import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tooltip } from 'primereact/tooltip';
import { ToggleButton } from 'primereact/togglebutton';
import Service from '../../services';
import { baseUrlAdmin } from '../../store/apiConstants';
import { connect } from 'react-redux';
import { getBranchesLatest } from '../../store/actions';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import ClassetInputText from '../../classetComponents/classetInputText';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import ClassetCalendar from '../../classetComponents/classetCalender';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import './PromotionPreview.css'; // Import the CSS file for styles
import { BoardsIconActive, BoardsIconInActive, GradesIcon, SectionIcon, } from '../svgIcons';
// import { textAlign } from 'html2canvas/dist/types/css/property-descriptors/text-align';

const BasicLazyParams = {
    first: 0,
    rows: 10,
    page: 1,
    sortField: null,
    sortOrder: null,
    filters: {}
};

class PromotionPreview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Original state
            feeScheduleData: [],
            admissionProcessData: [],
            // transportData: [],
            isLoading: false,
            error: null,
            selectedBranchForPreview: null,

            // Branch navigation state
            currentBranchIndex: 0,
            selectedBranches: [],
            currentBranchId: null,

            // Branch card expansion state
            expandedBranchId: null,
            branchCardsVisible: true,
            isTransitioning: false,

            // Fee Schedule state
            openCreateFeeScheduleDialog: false,
            feeTypes: [],
            lazyParams: BasicLazyParams,
            totalRecords: 0,
            branchId: '',
            selectedFeeTypes: [],
            filteredFeeTypes: [],
            isFeePlanBased: true,
            scheduleName: '',
            isEdit: false,
            editId: '',
            feeStructureInfo: [],
            globalFilter: '',
            plansData: [],
            selectedFeeStructure: null,
            selectedFeePlan: null,
            installmentData: [],
            oneTimeFees: [],
            scheduleInfo: [],
            openViewFeeScheduleDialog: false,
            viewFeeSchedule: {},
            originalFeeTypes: [],

            // Add these new state variables for branch selection display
            selectedBranchBoards: [],
            selectedBranchGrades: [],
            selectedBranchSections: [],

            // Add state for interactive board-grade-section selection
            allBranchData: [],
            selectedBoard: null,
            selectedGrade: null,
            boardData: [],
            gradeData: [],
            sectionData: [],

            // Add admission process state
            enrollAdmission: {},
            enrolladmissionData: {},

            // Add transport state
            // transportRoutes: [],
            // selectedTransportBranch: null

            // Confirmation dialog state
            showPromotionConfirmation: false,
            promotionSuccess: false,
            successMessage: ''
        };
        this.service = new Service();
        this.toast = React.createRef();

        // Add a method to verify toast is ready
        this.verifyToastReady = this.verifyToastReady.bind(this);
    }

    verifyToastReady = () => {
        if (this.toast && this.toast.current) {
            console.log('✅ Toast is ready and available');
            return true;
        } else {
            console.error('❌ Toast is not ready');
            console.log('Toast ref:', this.toast);
            console.log('Toast current:', this.toast?.current);
            return false;
        }
    }

    // Add this method to fetch admission process data
    getAdmissionEnrollData = async () => {
        const academicYear = localStorage.getItem("userAcademicYear");
        this.setState({ isLoading: true });
        let url = `${baseUrlAdmin}/admissions/process?academicYear=${academicYear}`;
        try {
            const res = await this.service.get(url, true);
            if (res?.res?.status && res.status) {
                this.setState({
                    enrolladmissionData: res?.res?.data,
                    enrollAdmission: res?.res?.data,
                    isLoading: false
                });
            } else {
                this.setState({ isLoading: false });
                this.showError(res?.message || 'Failed to fetch admission process data');
            }
        } catch (e) {
            console.log(e);
            this.setState({ isLoading: false });
            this.showError(e.message || 'Error fetching admission process data');
        }
    };

    // Add this method to fetch transport routes data
    // getTransportRoutesData = async (branchId = null) => {
    //     const academicYear = localStorage.getItem('userAcademicYear');
    //     const targetBranchId = branchId || this.state.currentBranchId;

    //     if (!targetBranchId) {
    //         this.setState({ transportRoutes: [] });
    //         return;
    //     }

    //     this.setState({ isLoading: true });
    //     let url = `${baseUrlAdmin}/transport-route/get-routes?academicYear=${academicYear}`;
    //     let payload = {
    //         branchId: targetBranchId,
    //         academicYear: academicYear
    //     };

    //     try {
    //         const res = await this.service.post(url, payload, true);
    //         if (res?.res?.status && res.status) {
    //             this.setState({
    //                 transportRoutes: res?.res?.data?.routeData || [],
    //                 isLoading: false
    //             });
    //         } else {
    //             this.setState({ isLoading: false, transportRoutes: [] });
    //             this.showError('Failed to fetch transport routes data');
    //         }
    //     } catch (e) {
    //         this.setState({ isLoading: false, transportRoutes: [] });
    //         this.showError(e.message || 'Error fetching transport routes');
    //     }
    // };

    async componentDidMount() {
        await this.props.getBranchesLatest(true);

        const { promotionData } = this.props;

        console.log('🚀 PromotionPreview componentDidMount');
        console.log('🔍 DEBUG: Initial promotionData:', promotionData);
        console.log('🔍 DEBUG: promotionData.selectedBranches:', promotionData?.selectedBranches);
        console.log('🔍 DEBUG: promotionData.branchSelections:', promotionData?.branchSelections);

        if (promotionData?.selectedBranches?.length > 0) {
            const selectedBranches = promotionData.selectedBranches;
            const firstBranchId = selectedBranches[0].branchId;

            console.log('✅ Setting up with first branch:', firstBranchId);

            this.setState({
                selectedBranches,
                currentBranchIndex: 0,
                currentBranchId: firstBranchId,
                branchId: firstBranchId,
                // Start with branch cards visible and no branch expanded
                branchCardsVisible: true,
                expandedBranchId: null
            });

            // Don't auto-load branch data initially, let user click on a branch card
        } else {
            console.log('❌ No selectedBranches found in promotionData');
        }

        // Only load admission data if admissions module is enabled for any branch
        const hasAdmissionsModule = promotionData?.data?.branches?.some(branch =>
            branch.moduleFlags?.showAdmissions
        );

        if (hasAdmissionsModule) {
            this.getAdmissionEnrollData();
        }
    }

    loadBranchData = (branchId) => {
        console.log('=== LOADING BRANCH DATA WITH MODULE CONDITIONS ===');
        console.log('Loading data for branch:', branchId);

        // Get the current branch from the data payload to check module selections
        const { promotionData } = this.props;
        const currentBranch = promotionData?.data?.branches?.find(branch => branch.branchId === branchId);

        console.log('Current branch data:', currentBranch);
        console.log('Module flags:', currentBranch?.moduleFlags);
        console.log('🎯 ABOUT TO CALL loadSelectedPromotionData with branchId:', branchId);

        this.setState({ branchId: branchId }, () => {
            // Always load selected promotion data
            this.loadSelectedPromotionData(branchId);

            // Conditionally load data based on module selections
            if (currentBranch?.moduleFlags?.showFeeSchedule) {
                console.log('✅ Fee Setup module selected - Loading fee schedule data');
                this.getFeeStructure();
                this.getInstallmentsList();
                this.getFeeScheduleData();
            } else {
                console.log('❌ Fee Setup module not selected - Skipping fee schedule data');
                this.setState({
                    feeStructureInfo: [],
                    plansData: [],
                    scheduleInfo: []
                });
            }

            // if (currentBranch?.moduleFlags?.showTransport) {
            //     console.log('✅ Transport module selected - Loading transport data');
            //     this.getTransportRoutesData(branchId);
            // } else {
            //     console.log('❌ Transport module not selected - Skipping transport data');
            //     this.setState({
            //         transportRoutes: []
            //     });
            // }

            // Always load admission data as it's mandatory
            // if (currentBranch?.moduleFlags?.showAdmissions) {
            //     // console.log('✅ Admissions module selected - Loading admission data');
            //     // Add admission data loading if needed
            // }

            // Always load Finance data 
            // if (currentBranch?.moduleFlags?.showAdmissions) {
            //     console.log('✅ Admissions module selected - Loading admission data');
            //     // Add admission data loading if needed
            // }
        });
    }

    // Add this missing method
    loadSelectedPromotionData = (branchId) => {
        const { promotionData } = this.props;

        console.log('🔍 DEBUG: loadSelectedPromotionData called with:', branchId);
        console.log('🔍 DEBUG: promotionData:', promotionData);

        if (!branchId || !promotionData) {
            console.log('❌ Missing branchId or promotionData');
            this.setState({
                selectedBranchBoards: [],
                selectedBranchGrades: [],
                selectedBranchSections: [],
                allBranchData: [],
                boardData: [],
                gradeData: [],
                sectionData: [],
                selectedBoard: null,
                selectedGrade: null
            });
            return;
        }

        // FIXED: Get the branch data from promotionData.allBranchData (not selectedBranches)
        const allBranches = promotionData.allBranchData || [];
        const currentBranchFullData = allBranches.find(branch => branch.branchId === branchId);

        // Get the selection data from promotionData.branchSelections
        const branchSelections = promotionData.branchSelections || {};
        const currentBranchSelection = branchSelections[branchId];

        console.log('🔍 DEBUG: allBranches from allBranchData:', allBranches);
        console.log('🔍 DEBUG: currentBranchFullData:', currentBranchFullData);
        console.log('🔍 DEBUG: branchSelections:', branchSelections);
        console.log('🔍 DEBUG: currentBranchSelection:', currentBranchSelection);

        if (currentBranchFullData) {
            const boardData = (currentBranchFullData.boards || []).map(board => ({
                ...board,
                selected: currentBranchSelection?.boards?.some(sb => sb.boardId === board.boardId) || false
            }));

            // Prepare all grades data with proper boardId relationship
            const gradeData = [];
            const sectionData = [];

            (currentBranchFullData.boards || []).forEach(board => {
                if (board.grades) {
                    board.grades.forEach(grade => {
                        gradeData.push({
                            ...grade,
                            boardId: board.boardId, // Add boardId for filtering
                            selected: currentBranchSelection?.grades?.some(sg => sg.gradeId === grade.gradeId) || false
                        });

                        // Prepare sections for this grade
                        if (grade.sections) {
                            grade.sections.forEach(section => {
                                sectionData.push({
                                    ...section,
                                    gradeId: grade.gradeId, // Add gradeId for filtering
                                    boardId: board.boardId, // Add boardId for filtering
                                    selected: currentBranchSelection?.sections?.some(ss => ss.sectionId === section.sectionId) || false
                                });
                            });
                        }
                    });
                }
            });

            console.log('✅ Found branch data in allBranchData');
            console.log('🔍 DEBUG: boardData to set:', boardData);
            console.log('🔍 DEBUG: gradeData to set:', gradeData);
            console.log('🔍 DEBUG: sectionData to set:', sectionData);

            this.setState({
                selectedBranchBoards: currentBranchSelection?.boards || [],
                selectedBranchGrades: currentBranchSelection?.grades || [],
                selectedBranchSections: currentBranchSelection?.sections || [],
                allBranchData: [currentBranchFullData],
                boardData: boardData,
                gradeData: gradeData,
                sectionData: sectionData,
                selectedBoard: null,
                selectedGrade: null
            });
        } else {
            console.log('❌ No branch data found in allBranchData for branchId:', branchId);
            this.setState({
                selectedBranchBoards: [],
                selectedBranchGrades: [],
                selectedBranchSections: [],
                allBranchData: [],
                boardData: [],
                gradeData: [],
                sectionData: [],
                selectedBoard: null,
                selectedGrade: null
            });
        }
    }

    // Add methods for interactive board-grade-section functionality
    onBoardClick = (boardId) => {
        if (this.state.selectedBoard === boardId) return; // Already selected

        this.setState({
            selectedBoard: boardId,
            selectedGrade: null
        });
        this.loadBoardSpecificData(boardId);
    }

    loadBoardSpecificData = (boardId) => {
        const { selectedBranchBoards, selectedBranchGrades, allBranchData } = this.state;

        if (!allBranchData.length) return;

        const currentBranch = allBranchData[0];
        const board = currentBranch?.boards?.find(b => b.boardId === boardId);

        if (!board) return;

        // Load grades for this specific board
        const gradesData = board.grades?.map(grade => ({
            ...grade,
            selected: selectedBranchGrades.some(sg => sg.gradeId === grade.gradeId)
        })) || [];

        this.setState({ gradeData: gradesData, sectionData: [] });

        // If there are selected grades for this board, update sections
        const selectedGradesForBoard = selectedBranchGrades.filter(grade =>
            board.grades?.some(bg => bg.gradeId === grade.gradeId)
        );

        if (selectedGradesForBoard.length > 0) {
            this.loadSectionsForSelectedGrades(gradesData, selectedGradesForBoard);
        }
    }

    onGradeClick = (gradeId) => {
        if (this.state.selectedGrade === gradeId) return; // Already selected

        this.setState({ selectedGrade: gradeId });
        this.loadGradeSpecificData(gradeId);
    }

    loadGradeSpecificData = (gradeId) => {
        const { selectedBranchSections, gradeData } = this.state;
        const grade = gradeData.find(g => g.gradeId === gradeId);

        if (!grade) return;

        // Load sections for this specific grade
        const sectionsData = grade.sections?.map(section => ({
            ...section,
            selected: selectedBranchSections.some(ss => ss.sectionId === section.sectionId)
        })) || [];

        this.setState({ sectionData: sectionsData });
    }

    loadSectionsForSelectedGrades = (gradesData, selectedGrades) => {
        const { selectedBranchSections } = this.state;
        const sectionsArray = [];

        gradesData.forEach(grade => {
            if (selectedGrades.some(sg => sg.gradeId === grade.gradeId)) {
                grade.sections?.forEach(section => {
                    sectionsArray.push({
                        ...section,
                        selected: selectedBranchSections.some(ss => ss.sectionId === section.sectionId)
                    });
                });
            }
        });

        this.setState({ sectionData: sectionsArray });
    }

    // Fee Schedule Methods (from FeeSchedule component)
    getFeeScheduleData = () => {
        let lazyParams = this.state.lazyParams;
        if (this.state.branchId) {
            this.setState({ isLoading: true });
            const academicYear = localStorage.getItem('userAcademicYear');
            const pageNumber = Math.floor(lazyParams.first / lazyParams.rows) + 1;
            let url = `${baseUrlAdmin}/fee-structure?academicYear=${academicYear}&branchId=${this.state.branchId}&limit=${lazyParams.rows}&page=${pageNumber}&search=${this.state.globalSearch}`;

            this.service.get(url, true)
                .then((response) => {
                    if (response?.status && response?.res?.data?.response) {
                        this.setState({
                            scheduleInfo: response?.res?.data?.response,
                            totalRecords: response?.res?.data?.totalRecords || 0,
                            isLoading: false
                        });
                    } else {
                        this.setState({ scheduleInfo: [], isLoading: false });
                    }
                })
                .catch((error) => {
                    console.error('Error fetching fee schedule data:', error);
                    this.setState({ scheduleInfo: [], isLoading: false });
                    this.showError('Failed to fetch fee schedule data');
                });
        }
    }

    getFeeStructure = () => {
        if (this.state.branchId) {
            this.setState({ isLoading: true });
            let url = `${baseUrlAdmin}/fee-category?academicYear=${localStorage.getItem('userAcademicYear')}&branchId=${this.state.branchId}`;
            this.service.get(url, true).then((data) => {
                if (data?.status && data?.res?.data?.response) {
                    this.setState({
                        feeStructureInfo: data?.res?.data?.response,
                        isLoading: false
                    });
                } else {
                    this.showError('An error occurred while Getting Fee Category');
                    this.setState({ feeStructureInfo: [], isLoading: false });
                }
            }).catch((error) => {
                this.showError('An error occurred while Getting Fee schedule');
                this.setState({ isLoading: false, feeStructureInfo: [] });
            });
        }
    }

    getInstallmentsList = async () => {
        const AcademicYear = localStorage.getItem('userAcademicYear');
        if (this.state.branchId === '') {
            this.setState({ isLoading: false });
        } else {
            let url = `${baseUrlAdmin}/feeInstallments?academicYear=${AcademicYear}&branchId=${this.state.branchId}`;
            try {
                const res = await this.service.get(url, true);
                if (res?.res?.status && res.status) {
                    this.setState({ plansData: res?.res?.data, isLoading: false });
                } else {
                    const error = 'Some error occurred';
                    this.setState({ error, isLoading: false });
                    this.showError(res?.message);
                }
            } catch (e) {
                console.log(e);
                this.setState({ e, isLoading: false });
                this.showError(e.message);
            }
        }
    }

    getFeeTypes = async () => {
        try {
            this.setState({ isLoading: true });
            const academicYear = localStorage.getItem('userAcademicYear');
            if (!academicYear) {
                this.showError('Academic year not found');
                return;
            }
            const payload = { academicYear };
            const url = `${baseUrlAdmin}/fee-types/info`;
            const response = await this.service.post(url, payload, true);
            if (response?.status && Array.isArray(response?.res?.data?.response)) {
                const allFeeTypes = response.res.data.response || [];
                const filteredFeeTypes = allFeeTypes.filter(feeType => feeType.isOneTime);

                this.setState({
                    isLoading: false,
                    feeTypes: filteredFeeTypes,
                    originalFeeTypes: filteredFeeTypes,
                });

                if (filteredFeeTypes.length === 0) {
                    this.showInfo('No one-time or transport fee types found for the selected academic year');
                }
            } else {
                this.setState({ isLoading: false });
                throw new Error(response?.message || 'Failed to fetch fee types');
            }
        } catch (error) {
            console.error('Error fetching fee types:', error);
            this.setState({ feeTypes: [] });
            this.showError(error.message || 'An error occurred while fetching fee types');
        } finally {
            this.setState({ isLoading: false });
        }
    }

    onHandleFeeScheduleDialog = () => {
        this.setState({ openCreateFeeScheduleDialog: true, isFeePlanBased: true });
    }

    onHideCreateFeeScheduleDialog = () => {
        this.setState({
            openCreateFeeScheduleDialog: false,
            scheduleName: '',
            filteredFeeTypes: [],
            selectedFeeTypes: [],
            isEdit: false,
            selectedFeeStructure: null,
            selectedFeePlan: null,
            installmentData: [],
        });
    }

    handleFeeStructureChange = (e) => {
        const selectedFeeStructure = this.state.feeStructureInfo.find(structure => structure._id === e.target.value);
        this.setState({ selectedFeeStructure }, () => {
            this.handleFeePlanChange({ target: { value: this.state.selectedFeePlan?._id } });
        });
    }

    handleFeePlanChange = (e) => {
        const selectedFeePlan = this.state.plansData.find(plan => plan._id === e.target.value);

        if (!selectedFeePlan || !this.state.selectedFeeStructure) {
            return;
        }

        const regularFees = this.state.selectedFeeStructure.feeTypes?.filter(fee => !fee.isOneTime);
        const oneTimeFees = this.state.selectedFeeStructure.feeTypes?.filter(fee => fee.isOneTime);

        const installmentData = selectedFeePlan.installments?.map((inst, index) => ({
            installment: `Installment ${index + 1}`,
            installmentId: inst.installmentId,
            dueDate: new Date(inst.date),
            feeTypes: regularFees?.map(feeType => ({
                ...feeType,
                percentage: 0,
                calculatedFee: 0
            }))
        }));

        const oneTimeFeeSection = oneTimeFees?.map(feeType => ({
            ...feeType,
            percentage: 100,
            calculatedFee: feeType.totalFee
        }));

        this.setState({
            selectedFeePlan,
            installmentData,
            oneTimeFees: oneTimeFeeSection
        });
    }

    handleFeeTypeSelection = (e) => {
        const selectedIds = e.target.value;
        const transportFee = this.state.originalFeeTypes.find(fee => fee.isTransportFeeType && selectedIds.includes(fee._id));

        if (transportFee && selectedIds.length > 1) {
            this.showError('Transport fee cannot be combined with other fee types');
            return;
        }

        const filteredTypes = this.state.originalFeeTypes.filter(feeType => selectedIds.includes(feeType._id));
        this.setState({ selectedFeeTypes: selectedIds, filteredFeeTypes: filteredTypes });
    }

    handlePercentageChange = (e, installmentIndex, rowData) => {
        const newPercentage = parseFloat(e.target.value) || 0;

        if (newPercentage < 0 || newPercentage > 100) {
            this.showError('Percentage must be between 0 and 100');
            return;
        }

        const updatedInstallmentData = [...this.state.installmentData];
        const currentInstallment = updatedInstallmentData[installmentIndex];

        if (!currentInstallment || !currentInstallment.feeTypes) {
            console.error('Invalid installment data');
            return;
        }

        const feeTypeIndex = currentInstallment.feeTypes.findIndex(fee =>
            fee.feeType === rowData.feeType && fee.feeTypeId === rowData.feeTypeId
        );

        if (feeTypeIndex === -1) {
            console.error('Fee type not found');
            return;
        }

        const newCalculatedFee = Math.round((newPercentage * rowData.totalFee) / 100);

        currentInstallment.feeTypes[feeTypeIndex] = {
            ...currentInstallment.feeTypes[feeTypeIndex],
            percentage: newPercentage,
            calculatedFee: newCalculatedFee
        };

        this.setState({ installmentData: updatedInstallmentData });
    }

    onPage = (event) => {
        this.setState({
            lazyParams: { ...this.state.lazyParams, first: event.first, rows: event.rows }
        }, this.getFeeScheduleData);
    }

    onEdit = async (scheduleData, isView) => {
        try {
            if (scheduleData?.planId) {
                const selectedFeePlan = this.state.plansData.find(plan => plan._id === scheduleData.planId);
                if (!selectedFeePlan) {
                    throw new Error('Associated fee plan not found');
                }

                const feeStructure = {
                    _id: scheduleData.feeCategory,
                    feeTypes: scheduleData.stepOne?.map(fee => ({
                        ...fee,
                        isOneTime: scheduleData.stepTwo.some(
                            stepTwoFee => stepTwoFee.feeTypeId === fee.feeTypeId && stepTwoFee.isOneTime
                        )
                    }))
                };

                const installmentData = selectedFeePlan.installments?.map((inst, index) => {
                    const installmentFees = scheduleData.stepTwo.filter(fee =>
                        fee.installmentId === inst.installmentId && !fee.isOneTime
                    );

                    return {
                        installment: `Installment ${index + 1}`,
                        installmentId: inst.installmentId,
                        dueDate: new Date(inst.date),
                        feeTypes: scheduleData.stepOne
                            .filter(fee => !scheduleData.stepTwo.some(
                                stepTwoFee => stepTwoFee.feeTypeId === fee.feeTypeId && stepTwoFee.isOneTime
                            ))
                            ?.map(feeType => {
                                const matchingFee = installmentFees.find(f => f.feeTypeId === feeType.feeTypeId);
                                return {
                                    ...feeType,
                                    ...(matchingFee?.isTransportFeeType && { isTransportFeeType: true }),
                                    percentage: matchingFee?.termWisePercentageOrValue || 0,
                                    calculatedFee: matchingFee?.termWiseActualValue || 0
                                };
                            })
                    };
                });

                const oneTimeFees = scheduleData.stepTwo
                    ?.filter(fee => fee.isOneTime)
                    ?.map(fee => {
                        const originalFeeType = scheduleData.stepOne.find(f => f.feeTypeId === fee.feeTypeId);
                        return {
                            ...originalFeeType,
                            ...fee,
                            percentage: 100,
                            calculatedFee: fee.termWiseActualValue,
                            dueDate: new Date(fee.dueDate),
                            isOneTime: true
                        };
                    });

                this.setState({
                    scheduleName: scheduleData.scheduleName,
                    selectedFeeStructure: feeStructure,
                    selectedFeePlan,
                    installmentData,
                    oneTimeFees,
                    branchId: scheduleData?.branchId,
                    isFeePlanBased: scheduleData?.planId ? true : false,
                    openViewFeeScheduleDialog: true,
                    viewFeeSchedule: scheduleData
                });
            } else {
                // Handle non-plan based fee schedules
                this.setState({
                    scheduleName: scheduleData.scheduleName,
                    selectedFeeStructure: null,
                    selectedFeePlan: null,
                    installmentData: [],
                    oneTimeFees: scheduleData.stepTwo || [],
                    branchId: scheduleData?.branchId,
                    isFeePlanBased: false,
                    openViewFeeScheduleDialog: true,
                    viewFeeSchedule: scheduleData
                });
            }
        } catch (error) {
            console.error('Error in onEdit:', error);
            this.showError(error.message || 'Failed to load fee schedule for viewing');
        }
    }

    onHideViewFeeScheduleDialog = () => {
        this.setState({
            openViewFeeScheduleDialog: false,
            viewFeeSchedule: {},
            scheduleName: '',
            selectedFeeStructure: null,
            selectedFeePlan: null,
            installmentData: [],
            oneTimeFees: []
        });
    }

    async loadPreviewData() {
        this.setState({ isLoading: true });
        try {
            await Promise.all([
                this.loadFeeScheduleData(),
                this.loadAdmissionProcessData(),
                // this.loadTransportData()
            ]);
        } catch (error) {
            console.error('Error loading preview data:', error);
            this.showError('Failed to load preview data');
        } finally {
            this.setState({ isLoading: false });
        }
    }

    loadFeeScheduleData = async () => {
        const { promotionData } = this.props;
        const academicYear = promotionData?.academicYear || localStorage.getItem('userAcademicYear');
        const branchId = this.state.selectedBranchForPreview;

        if (!academicYear) return;

        try {
            let url = `${baseUrlAdmin}/fee-structure?academicYear=${academicYear}&limit=100&page=1&search=`;

            if (branchId) {
                url += `&branchId=${branchId}`;
            }

            const response = await this.service.get(url, true);

            if (response?.status && response?.res?.data?.response) {
                let filteredData = response.res.data.response;

                if (promotionData?.selectedGrades?.length > 0) {
                    const selectedGradeIds = promotionData.selectedGrades.map(g => g.gradeId);
                    filteredData = filteredData.filter(fee =>
                        fee.stepOne?.some(step => selectedGradeIds.includes(step.gradeId))
                    );
                }

                this.setState({ feeScheduleData: filteredData });
            }
        } catch (error) {
            console.error('Error loading fee schedule data:', error);
        }
    }

    loadAdmissionProcessData = async () => {
        const { promotionData } = this.props;
        const academicYear = promotionData?.academicYear || localStorage.getItem('userAcademicYear');

        if (!academicYear) return;

        try {
            const url = `${baseUrlAdmin}/admission-process/current?academicYear=${academicYear}`;
            const response = await this.service.get(url, true);

            if (response.status && response.res?.data) {
                this.setState({ admissionProcessData: response.res.data });
            }
        } catch (error) {
            console.error('Error loading admission process data:', error);
        }
    }

    // loadTransportData = async () => {
    //     const { promotionData } = this.props;
    //     const academicYear = promotionData?.academicYear || localStorage.getItem('userAcademicYear');
    //     const branchId = this.state.selectedBranchForPreview;

    //     if (!academicYear) return;

    //     try {
    //         let url = `${baseUrlAdmin}/transport/routes?academicYear=${academicYear}`;

    //         if (branchId) {
    //             url += `&branchId=${branchId}`;
    //         }

    //         const response = await this.service.get(url, true);

    //         if (response.status && response.res?.data) {
    //             let filteredData = response.res.data;

    //             if (promotionData?.selectedBranches?.length > 0 && !branchId) {
    //                 const selectedBranchIds = promotionData.selectedBranches.map(b => b.branchId);
    //                 filteredData = filteredData.filter(transport =>
    //                     selectedBranchIds.includes(transport.branchId)
    //                 );
    //             }

    //             this.setState({ transportData: filteredData });
    //         }
    //     } catch (error) {
    //         console.error('Error loading transport data:', error);
    //     }
    // }

    showError = (message) => {
        console.log('🔍 DEBUG showError called with:', message);

        // Verify toast is ready
        if (this.verifyToastReady()) {
            this.toast.current.show({
                severity: 'error',
                summary: 'Promotion Failed!',
                detail: message,
                life: 4000,
                sticky: false
            });
        } else {
            console.error('❌ Toast is not ready! Using alert as fallback');
            // alert(`Promotion Failed: ${message}`);

            // Try to initialize toast after a delay
            setTimeout(() => {
                if (this.verifyToastReady()) {
                    console.log('✅ Toast became ready after delay, showing message');
                    this.toast.current.show({
                        severity: 'error',
                        summary: 'Promotion Failed!',
                        detail: message,
                        life: 4000,
                        sticky: false
                    });
                }
            }, 100);
        }
    }

    showSuccess = (message) => {
        if (this.toast.current) {
            this.toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: message,
                life: 3000
            });
        }
    }

    showInfo = (message) => {
        if (this.toast.current) {
            this.toast.current.show({
                severity: 'info',
                summary: 'Information',
                detail: message,
                life: 3000
            });
        }
    }

    handleBack = () => {
        this.props.onBack && this.props.onBack();
    }

    handleSubmit = async () => {
        // Show confirmation dialog instead of directly promoting
        this.setState({ showPromotionConfirmation: true });
    }

    handleConfirmPromotion = async () => {
        this.setState({
            showPromotionConfirmation: false,
            isLoading: true
        });

        try {
            const { promotionData } = this.props;
            console.log('Submitting promotion data=====:', promotionData);
            const url = `${baseUrlAdmin}/promotions/promote`;

            // Create a deep copy of promotionData to avoid modifying original
            const cleanedPromotionData = JSON.parse(JSON.stringify(promotionData));

            //promotionData.data remove moduleMetadata, moduleFlags, modules
            // Remove unwanted properties from promotionData.data
            if (cleanedPromotionData.data) {
                // Remove moduleMetadata, moduleFlags, and modules from each branch
                if (cleanedPromotionData.data.branches) {
                    cleanedPromotionData.data.branches = cleanedPromotionData.data.branches.map(branch => {
                        const cleanedBranch = { ...branch };

                        // Remove the unwanted properties
                        delete cleanedBranch.moduleMetadata;
                        delete cleanedBranch.moduleFlags;
                        delete cleanedBranch.modules;

                        // Clean up boards, grades, and sections by removing studentCount
                        if (cleanedBranch.boards) {
                            cleanedBranch.boards = cleanedBranch.boards.map(board => {
                                const cleanedBoard = { ...board };

                                if (cleanedBoard.grades) {
                                    cleanedBoard.grades = cleanedBoard.grades.map(grade => {
                                        const cleanedGrade = { ...grade };

                                        // if (cleanedGrade.sections) {
                                        //     cleanedGrade.sections = cleanedGrade.sections.map(section => {
                                        //         const cleanedSection = { ...section };

                                        //         // Remove studentCount from sections
                                        //         delete cleanedSection.studentCount;

                                        //         return cleanedSection;
                                        //     });
                                        // }

                                        return cleanedGrade;
                                    });
                                }

                                return cleanedBoard;
                            });
                        }

                        console.log(`Cleaned branch ${branch.branchName}:`, cleanedBranch);
                        return cleanedBranch;
                    });
                }

                // Also remove any top-level moduleMetadata if it exists
                delete cleanedPromotionData.data.moduleMetadata;
                // delete cleanedPromotionData.data.selectionHistory;
            }

            const submissionData = {
                promotionData: cleanedPromotionData.data,
                orgId: localStorage.getItem('orgId'),
                submittedAt: new Date().toISOString(),
                status: 'pending'
            };

            const response = await this.service.post(url, submissionData, true);

            if (response.status) {
                // Handle successful response
                console.log('Promotion submitted successfully:', response.data);
                this.toast.current.show({
                    severity: 'success',
                    summary: '🎉 Promotion Successful!',
                    detail: response.res.message,
                    life: 6000,  // Longer display time for promotion success
                    sticky: false
                });

                // Set success state to show success message on overlay
                this.setState({
                    promotionSuccess: true,
                    successMessage: response.res.message || 'Promotion completed successfully!'
                });

                // Redirect to home page after showing success message
                // setTimeout(() => {
                window.location.href = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/`;
                // }, 3000); // 3 second delay to show success message

            } else {
                console.log('🔍 DEBUG: About to show error toast');
                console.log('🔍 DEBUG: this.toast:', this.toast);
                console.log('🔍 DEBUG: this.toast?.current:', this.toast?.current);

                this.showError(response?.message || 'Failed to process academic year transfer');
            }
        } catch (error) {
            console.error('Error submitting promotion data:', error);
            console.log('🔍 DEBUG: About to show error toast in catch');
            console.log('🔍 DEBUG: this.toast:', this.toast);
            console.log('🔍 DEBUG: this.toast?.current:', this.toast?.current);

            this.showError(error?.message || 'Error submitting academic year transfer');
        } finally {
            this.setState({ isLoading: false });
        }
    }
    handleCancelPromotion = () => {
        this.setState({ showPromotionConfirmation: false });
    }

    handleCancel = () => {
        this.props.onCancel && this.props.onCancel();
    }

    getCurrentBranchName = () => {
        const { currentBranchId } = this.state;
        const branch = this.props.branchData.find(b => b.key === currentBranchId);
        return branch ? branch.name : 'Unknown Branch';
    }

    // Fee Schedule Create Dialog
    onHandleFeeScheduleDialog = () => {
        this.setState({ openCreateFeeScheduleDialog: true, isFeePlanBased: true });
    }

    onHideCreateFeeScheduleDialog = () => {
        this.setState({
            openCreateFeeScheduleDialog: false,
            scheduleName: '',
            filteredFeeTypes: [],
            selectedFeeTypes: [],
            isEdit: false,
            selectedFeeStructure: null,
            selectedFeePlan: null,
            installmentData: [],
        });
    }

    handleFeeStructureChange = (e) => {
        const selectedFeeStructure = this.state.feeStructureInfo.find(structure => structure._id === e.target.value);
        this.setState({ selectedFeeStructure }, () => {
            this.handleFeePlanChange({ target: { value: this.state.selectedFeePlan?._id } });
        });
    }

    handleFeePlanChange = (e) => {
        const selectedFeePlan = this.state.plansData.find(plan => plan._id === e.target.value);

        if (!selectedFeePlan || !this.state.selectedFeeStructure) {
            return;
        }

        const regularFees = this.state.selectedFeeStructure.feeTypes?.filter(fee => !fee.isOneTime);
        const oneTimeFees = this.state.selectedFeeStructure.feeTypes?.filter(fee => fee.isOneTime);

        const installmentData = selectedFeePlan.installments?.map((inst, index) => ({
            installment: `Installment ${index + 1}`,
            installmentId: inst.installmentId,
            dueDate: new Date(inst.date),
            feeTypes: regularFees?.map(feeType => ({
                ...feeType,
                percentage: 0,
                calculatedFee: 0
            }))
        }));

        const oneTimeFeeSection = oneTimeFees?.map(feeType => ({
            ...feeType,
            percentage: 100,
            calculatedFee: feeType.totalFee
        }));

        this.setState({
            selectedFeePlan,
            installmentData,
            oneTimeFees: oneTimeFeeSection
        });
    }

    handleFeeTypeSelection = (e) => {
        const selectedIds = e.target.value;
        const transportFee = this.state.originalFeeTypes.find(fee => fee.isTransportFeeType && selectedIds.includes(fee._id));

        if (transportFee && selectedIds.length > 1) {
            this.showError('Transport fee cannot be combined with other fee types');
            return;
        }

        const filteredTypes = this.state.originalFeeTypes.filter(feeType => selectedIds.includes(feeType._id));
        this.setState({ selectedFeeTypes: selectedIds, filteredFeeTypes: filteredTypes });
    }

    handlePercentageChange = (e, installmentIndex, rowData) => {
        const newPercentage = parseFloat(e.target.value) || 0;

        if (newPercentage < 0 || newPercentage > 100) {
            this.showError('Percentage must be between 0 and 100');
            return;
        }

        const updatedInstallmentData = [...this.state.installmentData];
        const currentInstallment = updatedInstallmentData[installmentIndex];

        if (!currentInstallment || !currentInstallment.feeTypes) {
            console.error('Invalid installment data');
            return;
        }

        const feeTypeIndex = currentInstallment.feeTypes.findIndex(fee =>
            fee.feeType === rowData.feeType && fee.feeTypeId === rowData.feeTypeId
        );

        if (feeTypeIndex === -1) {
            console.error('Fee type not found');
            return;
        }

        const newCalculatedFee = Math.round((newPercentage * rowData.totalFee) / 100);

        currentInstallment.feeTypes[feeTypeIndex] = {
            ...currentInstallment.feeTypes[feeTypeIndex],
            percentage: newPercentage,
            calculatedFee: newCalculatedFee
        };

        this.setState({ installmentData: updatedInstallmentData });
    }

    onPage = (event) => {
        this.setState({
            lazyParams: { ...this.state.lazyParams, first: event.first, rows: event.rows }
        }, this.getFeeScheduleData);
    }

    onEdit = async (scheduleData, isView) => {
        try {
            if (scheduleData?.planId) {
                const selectedFeePlan = this.state.plansData.find(plan => plan._id === scheduleData.planId);
                if (!selectedFeePlan) {
                    throw new Error('Associated fee plan not found');
                }

                const feeStructure = {
                    _id: scheduleData.feeCategory,
                    feeTypes: scheduleData.stepOne?.map(fee => ({
                        ...fee,
                        isOneTime: scheduleData.stepTwo.some(
                            stepTwoFee => stepTwoFee.feeTypeId === fee.feeTypeId && stepTwoFee.isOneTime
                        )
                    }))
                };

                const installmentData = selectedFeePlan.installments?.map((inst, index) => {
                    const installmentFees = scheduleData.stepTwo.filter(fee =>
                        fee.installmentId === inst.installmentId && !fee.isOneTime
                    );

                    return {
                        installment: `Installment ${index + 1}`,
                        installmentId: inst.installmentId,
                        dueDate: new Date(inst.date),
                        feeTypes: scheduleData.stepOne
                            .filter(fee => !scheduleData.stepTwo.some(
                                stepTwoFee => stepTwoFee.feeTypeId === fee.feeTypeId && stepTwoFee.isOneTime
                            ))
                            ?.map(feeType => {
                                const matchingFee = installmentFees.find(f => f.feeTypeId === feeType.feeTypeId);
                                return {
                                    ...feeType,
                                    ...(matchingFee?.isTransportFeeType && { isTransportFeeType: true }),
                                    percentage: matchingFee?.termWisePercentageOrValue || 0,
                                    calculatedFee: matchingFee?.termWiseActualValue || 0
                                };
                            })
                    };
                });

                const oneTimeFees = scheduleData.stepTwo
                    ?.filter(fee => fee.isOneTime)
                    ?.map(fee => {
                        const originalFeeType = scheduleData.stepOne.find(f => f.feeTypeId === fee.feeTypeId);
                        return {
                            ...originalFeeType,
                            ...fee,
                            percentage: 100,
                            calculatedFee: fee.termWiseActualValue,
                            dueDate: new Date(fee.dueDate),
                            isOneTime: true
                        };
                    });

                this.setState({
                    scheduleName: scheduleData.scheduleName,
                    selectedFeeStructure: feeStructure,
                    selectedFeePlan,
                    installmentData,
                    oneTimeFees,
                    branchId: scheduleData?.branchId,
                    isFeePlanBased: scheduleData?.planId ? true : false,
                    openViewFeeScheduleDialog: true,
                    viewFeeSchedule: scheduleData
                });
            } else {
                // Handle non-plan based fee schedules
                this.setState({
                    scheduleName: scheduleData.scheduleName,
                    selectedFeeStructure: null,
                    selectedFeePlan: null,
                    installmentData: [],
                    oneTimeFees: scheduleData.stepTwo || [],
                    branchId: scheduleData?.branchId,
                    isFeePlanBased: false,
                    openViewFeeScheduleDialog: true,
                    viewFeeSchedule: scheduleData
                });
            }
        } catch (error) {
            console.error('Error in onEdit:', error);
            this.showError(error.message || 'Failed to load fee schedule for viewing');
        }
    }

    onHideViewFeeScheduleDialog = () => {
        this.setState({
            openViewFeeScheduleDialog: false,
            viewFeeSchedule: {},
            scheduleName: '',
            selectedFeeStructure: null,
            selectedFeePlan: null,
            installmentData: [],
            oneTimeFees: []
        });
    }

    async loadPreviewData() {
        this.setState({ isLoading: true });
        try {
            await Promise.all([
                this.loadFeeScheduleData(),
                this.loadAdmissionProcessData(),
                // this.loadTransportData()
            ]);
        } catch (error) {
            console.error('Error loading preview data:', error);
            this.showError('Failed to load preview data');
        } finally {
            // this.setState({ isLoading: false });
        }
    }

    loadFeeScheduleData = async () => {
        const { promotionData } = this.props;
        const academicYear = promotionData?.academicYear || localStorage.getItem('userAcademicYear');
        const branchId = this.state.selectedBranchForPreview;

        if (!academicYear) return;

        try {
            let url = `${baseUrlAdmin}/fee-structure?academicYear=${academicYear}&limit=100&page=1&search=`;

            if (branchId) {
                url += `&branchId=${branchId}`;
            }

            const response = await this.service.get(url, true);

            if (response?.status && response?.res?.data?.response) {
                let filteredData = response.res.data.response;

                if (promotionData?.selectedGrades?.length > 0) {
                    const selectedGradeIds = promotionData.selectedGrades.map(g => g.gradeId);
                    filteredData = filteredData.filter(fee =>
                        fee.stepOne?.some(step => selectedGradeIds.includes(step.gradeId))
                    );
                }

                this.setState({ feeScheduleData: filteredData });
            }
        } catch (error) {
            console.error('Error loading fee schedule data:', error);
        }
    }

    loadAdmissionProcessData = async () => {
        const { promotionData } = this.props;
        const academicYear = promotionData?.academicYear || localStorage.getItem('userAcademicYear');

        if (!academicYear) return;

        try {
            const url = `${baseUrlAdmin}/admission-process/current?academicYear=${academicYear}`;
            const response = await this.service.get(url, true);

            if (response.status && response.res?.data) {
                this.setState({ admissionProcessData: response.res.data });
            }
        } catch (error) {
            console.error('Error loading admission process data:', error);
        }
    }

    // loadTransportData = async () => {
    //     const { promotionData } = this.props;
    //     const academicYear = promotionData?.academicYear || localStorage.getItem('userAcademicYear');
    //     const branchId = this.state.selectedBranchForPreview;

    //     if (!academicYear) return;

    //     try {
    //         let url = `${baseUrlAdmin}/transport/routes?academicYear=${academicYear}`;

    //         if (branchId) {
    //             url += `&branchId=${branchId}`;
    //         }

    //         const response = await this.service.get(url, true);

    //         if (response.status && response.res?.data) {
    //             let filteredData = response.res.data;

    //             if (promotionData?.selectedBranches?.length > 0 && !branchId) {
    //                 const selectedBranchIds = promotionData.selectedBranches.map(b => b.branchId);
    //                 filteredData = filteredData.filter(transport =>
    //                     selectedBranchIds.includes(transport.branchId)
    //                 );
    //             }

    //             this.setState({ transportData: filteredData });
    //         }
    //     } catch (error) {
    //         console.error('Error loading transport data:', error);
    //     }
    // }

    // Update the getCurrentBranchModuleFlags helper method
    getCurrentBranchModuleFlags = () => {
        const { promotionData } = this.props;
        const { currentBranchId } = this.state;

        if (!currentBranchId || !promotionData?.data?.branches) {
            return {
                showFeeSchedule: false,
                // showTransport: false,
                showAdmissions: false,
                showFinance: false,
                showFinanceGeneralSettings: false
            };
        }

        const currentBranch = promotionData.data.branches.find(branch => branch.branchId === currentBranchId);
        return currentBranch?.moduleFlags || {
            showFeeSchedule: false,
            // showTransport: false,
            showAdmissions: false,
            showFinance: false,
            showFinanceGeneralSettings: false
        };
    }

    // Branch card expansion methods
    handleBranchCardClick = (branchId) => {
        const { expandedBranchId, isTransitioning } = this.state;

        // Prevent multiple clicks during transition
        if (isTransitioning) return;

        if (expandedBranchId === branchId) {
            // Collapse if already expanded - transition from expanded back to cards
            this.setState({ isTransitioning: true });

            // Start exit transition
            setTimeout(() => {
                this.setState({
                    expandedBranchId: null,
                    branchCardsVisible: true,
                    isTransitioning: false
                });
            }, 150); // Small delay for smooth transition

        } else {
            // Expand the clicked branch - transition from cards to expanded view
            this.setState({ isTransitioning: true });

            // First hide the branch cards with slide up effect
            this.setState({ branchCardsVisible: false });

            // After cards are hidden, show expanded content with slide down effect
            setTimeout(() => {
                this.setState({
                    expandedBranchId: branchId,
                    currentBranchId: branchId,
                    isTransitioning: false
                }, () => {
                    // Load data for the expanded branch
                    this.loadBranchData(branchId);

                    // Update current branch info
                    const { selectedBranches } = this.state;
                    const branchIndex = selectedBranches.findIndex(branch => branch.branchId === branchId);
                    if (branchIndex !== -1) {
                        this.setState({ currentBranchIndex: branchIndex });
                    }
                });
            }, 300); // Wait for branch cards to slide up before showing expanded content
        }
    }

    handleBackToBranchCards = () => {
        this.setState({
            expandedBranchId: null,
            branchCardsVisible: true,
            selectedBoard: null,
            selectedGrade: null,
            boardData: [],
            gradeData: [],
            sectionData: []
        });
    }

    // Enhanced navigation methods that work with expanded view
    handleNext = () => {
        const { currentBranchIndex, selectedBranches, expandedBranchId } = this.state;
        const nextIndex = currentBranchIndex + 1;

        if (nextIndex < selectedBranches.length) {
            const nextBranchId = selectedBranches[nextIndex].branchId;

            this.setState({
                currentBranchIndex: nextIndex,
                currentBranchId: nextBranchId,
                branchId: nextBranchId,
                expandedBranchId: expandedBranchId ? nextBranchId : null,
                selectedBoard: null,
                selectedGrade: null,
                boardData: [],
                gradeData: [],
                sectionData: []
            }, () => {
                if (expandedBranchId) {
                    this.loadBranchData(nextBranchId);
                }
            });
        } else {
            // This is the last branch, handle promotion
            this.handleSubmit();
        }
    }

    handlePrevious = () => {
        const { currentBranchIndex, selectedBranches, expandedBranchId } = this.state;
        const prevIndex = currentBranchIndex - 1;

        if (prevIndex >= 0) {
            const prevBranchId = selectedBranches[prevIndex].branchId;

            this.setState({
                currentBranchIndex: prevIndex,
                currentBranchId: prevBranchId,
                branchId: prevBranchId,
                expandedBranchId: expandedBranchId ? prevBranchId : null,
                selectedBoard: null,
                selectedGrade: null,
                boardData: [],
                gradeData: [],
                sectionData: []
            }, () => {
                if (expandedBranchId) {
                    this.loadBranchData(prevBranchId);
                }
            });
        }
    }

    render() {
        const { promotionData } = this.props;
        const {
            isLoading,
            currentBranchIndex,
            currentBranchId,
            selectedBranches,
            scheduleInfo,
            lazyParams,
            totalRecords,
            selectedBranchBoards,
            selectedBranchGrades,
            selectedBranchSections,
            transportRoutes,
            // Interactive selection states
            boardData,
            gradeData,
            sectionData,
            selectedBoard,
            selectedGrade,
            // Fee Schedule states
            openCreateFeeScheduleDialog,
            scheduleName,
            selectedFeeStructure,
            selectedFeePlan,
            isFeePlanBased,
            feeStructureInfo,
            plansData,
            installmentData,
            oneTimeFees,
            openViewFeeScheduleDialog,
            viewFeeSchedule,
            // Branch expansion states
            expandedBranchId,
            branchCardsVisible,
            isTransitioning,
            showPromotionConfirmation,
            promotionSuccess,
            successMessage,
        } = this.state;

        const isLastBranch = currentBranchIndex === selectedBranches.length - 1;
        const isFirstBranch = currentBranchIndex === 0;

        // Get current branch module flags
        const moduleFlags = this.getCurrentBranchModuleFlags();

        console.log('Rendering with module flags:', moduleFlags);

        return (
            <div className="promotion-preview">
                <Toast ref={this.toast} position="bottom-right" />

                {/* Branch Cards Section */}
                <div className={`branch-cards-container ${branchCardsVisible ? 'visible' : 'hidden'}`}>
                    <Card className="">
                        <div className="">
                            <h2 className="text-2xl font-bold text-gray-800 mb-6">School Branch Configuration Preview</h2>

                            {/* show target academic year */}
                            {/* <h1 className=''>
                                Target Academic Year: {promotionData?.targetAcademicYear}
                            </h1> */}

                            <div className="grid">
                                {selectedBranches.map((branch, index) => {
                                    const branchModules = promotionData?.data?.branches?.find(b => b.branchId === branch.branchId)?.moduleFlags || {};
                                    const activeModules = Object.keys(branchModules).filter(key => branchModules[key]);
                                    const isCurrentBranch = currentBranchId === branch.branchId;
                                    const isExpanded = expandedBranchId === branch.branchId;

                                    // Calculate board count from branchSelections
                                    const branchSelection = promotionData?.branchSelections?.[branch.branchId];
                                    const boardCount = branchSelection?.boards?.length || 0;

                                    return (
                                        <div key={branch.branchId} className="col-12">
                                            <div
                                                className={`branch-card ${isExpanded ? 'expanded' : ''} ${isTransitioning ? 'transitioning' : ''}`}
                                                onClick={() => this.handleBranchCardClick(branch.branchId)}
                                                style={{
                                                    pointerEvents: isTransitioning ? 'none' : 'auto',
                                                    opacity: isTransitioning && !isExpanded ? 0.7 : 1,
                                                    animationDelay: `${index * 0.1}s`
                                                }}
                                                data-index={index}
                                            >
                                                <div className="branch-card-content">
                                                    <div className="flex flex-column gap-3">
                                                        <div className="flex align-items-center gap-4">
                                                            {/* <div className="branch-icon">
                                                                <i className="pi pi-building text-2xl text-white"></i>
                                                            </div> */}
                                                            <div className="flex-1">
                                                                <div className="flex align-items-center gap-1 mb-1">
                                                                    <h3 className="branch-title m-0">{branch.branchName}</h3>
                                                                </div>
                                                                <p className="branch-subtitle m-0">
                                                                    {boardCount} Boards | {activeModules.length} Modules
                                                                </p>
                                                                {/* • {branch.gradeCount} grade(s) • {branch.sectionCount} section(s) */}
                                                            </div>
                                                            {/* <div className="flex align-items-center gap-2">
                                                                <div className="text-sm text-gray-500">
                                                                    {isExpanded ? 'Click to collapse' : 'Click to configure'}
                                                                </div>
                                                                <i className={`pi ${isExpanded ? 'pi-chevron-up' : 'pi-chevron-right'} text-gray-400`}></i>
                                                            </div> */}
                                                        </div>
                                                        <div className="flex align-items-center gap-4">
                                                            <div className="branch-modules">
                                                                {activeModules.map(moduleKey => (
                                                                    <span key={moduleKey} className="module-badge">
                                                                        {moduleKey === 'showAdmissions' && 'Admissions'}
                                                                        {moduleKey === 'showFinanceGeneralSettings' && 'Finance Settings'}
                                                                        {moduleKey === 'showFeeSchedule' && 'Fee Setup'}
                                                                        {moduleKey === 'showFinance' && 'Finance'}
                                                                        {moduleKey === 'showTransport' && 'Transport'}
                                                                    </span>
                                                                ))}
                                                                {activeModules.length === 0 && (
                                                                    <span className="module-badge">No modules selected</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </Card>
                </div>

                {/* Action Buttons for Branch Cards View - Always visible at bottom */}
                {branchCardsVisible && !expandedBranchId && (
                    <div className="promotion-footer flex justify-content-center gap-3 mt-4 mb-4">
                        <Button
                            label={isLoading ? "Promoting..." : "Promote All"}
                            // icon={isLoading ? "pi pi-spin pi-spinner" : "pi pi-check"}
                            iconPos="right"
                            className="p-button promotion-next-btn"
                            style={{
                                borderRadius: '12px',
                                padding: '12px 24px',
                                fontSize: '16px',
                                fontWeight: '600',
                                backgroundColor: !isLoading ? '#3B82F6' : '#9CA3AF',
                                color: '#ffffff',
                                width: '286px',
                                height: '48px',
                                cursor: !isLoading ? 'pointer' : 'not-allowed',
                                transition: 'all 0.3s ease'
                            }}
                            onClick={this.handleSubmit}
                            disabled={isLoading}
                        />
                        <Button
                            label="Back"
                            // icon="pi pi-arrow-left"
                            className=" promotion-cancel-btn"
                            style={{
                                borderRadius: '12px',
                                padding: '12px 24px',
                                fontSize: '16px',
                                fontWeight: '600',
                                // border: '2px solid #E5E7EB',
                                border: '0px solid black',

                                color: '#6B7280',
                                backgroundColor: '#F4F5F6',
                                width: '150px',
                                height: '48px'
                            }}
                            onClick={this.handleBack}
                            disabled={isLoading}
                        />
                        <Button
                            label="Cancel"
                            // icon="pi pi-times"
                            className=" promotion-cancel-btn"
                            style={{
                                borderRadius: '12px',
                                padding: '12px 24px',
                                fontSize: '16px',
                                fontWeight: '600',
                                // border: '2px solid #E5E7EB',
                                border: '0px solid black',

                                color: '#6B7280',
                                backgroundColor: '#F4F5F6',
                                width: '150px',
                                height: '48px'
                            }}
                            onClick={this.handleCancel}
                            disabled={isLoading}
                        />
                    </div>
                )}

                {/* Expanded Branch Content */}
                <div className={`expanded-content-container ${expandedBranchId ? 'entered' : 'entering'}`}>
                    {expandedBranchId && (
                        <>
                            {/* Back to Branches Button */}
                            {/* <div className="mb-4">
                                <Button
                                    label="Back to Branches"
                                    icon="pi pi-arrow-left"
                                    className="p-button-outlined back-to-branches-btn"
                                    onClick={this.handleBackToBranchCards}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '12px 24px',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        color: '#6B7280',
                                        backgroundColor: '#F4F5F6'
                                    }}
                                />
                            </div> */}

                            <Card className="mb-4" style={{ border: 'none', boxShadow: 'none' }}>
                                {/* Branch Navigation Header */}
                                {/* <div className="mb-4 p-3 bg-blue-50 border-radius-md"> */}
                                {/* <div className="flex align-items-center justify-content-between"> */}
                                <div>
                                    {/* <h3 className="m-0 text-blue-700 font-semibold">
                                                Branch {currentBranchIndex + 1} of {selectedBranches.length}: {this.getCurrentBranchName()}
                                            </h3> */}
                                    {/* <p className="mt-1 mb-0 text-blue-600 ">
                                                Review your selected boards, grades, and sections configuration
                                            </p> */}

                                    {/* Show selected modules for current branch */}
                                    {/* <div className="mt-2 flex flex-wrap gap-1"> */}
                                    {/* {moduleFlags.showAdmissions && (
                                                    <Badge value="Admissions" severity="info" className="mr-1" />
                                                )}
                                                {moduleFlags.showFinanceGeneralSettings && (
                                                    <Badge value="Finance General Settings" severity="info" className="mr-1" />
                                                )}
                                                {moduleFlags.showFeeSchedule && (
                                                    <Badge value="Fee Setup" severity="success" className="mr-1" />
                                                )} */}
                                    {/* {moduleFlags.showTransport && (
                                        <Badge value="Transport" severity="warning" className="mr-1" />
                                    )} */}
                                    {/* {moduleFlags.showFinance && (
                                                    <Badge value="Finance" severity="help" className="mr-1" />
                                                )} */}
                                    {/* </div> */}
                                </div>
                                {/* <div className=''>
                                            <div className='m-0 text-blue-700 font-semibold'>
                                                <h4>Target Academic Year: {this.props.targetAcademicYearName}
                                                </h4>
                                            </div>
                                            <div className="flex align-items-center gap-2">
                                                <div className="text-blue-700 text-sm">
                                                    Progress: {currentBranchIndex + 1}/{selectedBranches.length}
                                                </div>
                                                <div className="w-20rem bg-blue-200 border-radius-md" style={{ height: '8px' }}>
                                                    <div
                                                        className="bg-blue-500 border-radius-md h-full transition-all duration-300"
                                                        style={{ width: `${((currentBranchIndex + 1) / selectedBranches.length) * 100}%` }}
                                                    ></div>
                                                </div>
                                            </div>
                                        </div> */}

                                {/* </div> */}

                                {/* </div> */}



                                {/* build UI for branch data */}
                                <h3 style={{ textAlign: 'left' }} className='ml-4'>  {this.getCurrentBranchName()}</h3>
                                {/* {this.getCurrentBranchName()} */}
                                <p className='ml-4'> Review your selected boards, grades, and sections configuration </p>
                                {/* Branch Data Summary Cards */}
                                <div className="mt-4 mb-4 ml-4">
                                    <div className="grid">
                                        {/* Total Boards Card */}
                                        <div className="col-4">
                                            <div className="bg-white border-round-lg shadow-2 p-4" style={{ width: '370px', height: '84px' }}>
                                                <div className="flex align-items-center justify-content-between">
                                                    <div className="flex align-items-center">
                                                        <div className="bg-black-100 border-round-md p-3 mr-3">
                                                            {/* <i className="pi pi-folder text-2xl text-blue-600"></i> */}
                                                            <BoardsIconInActive className="bg-black-100" height={19.5} width={21} />
                                                        </div>
                                                        <div>
                                                            <h3 className="text-xl font-bold text-gray-800 m-0">Total Boards</h3>
                                                            <p className="text-gray-600 text-sm m-0 mt-1">
                                                                {boardData.filter(board => board.selected).length} Board{boardData.filter(board => board.selected).length !== 1 ? 's' : ''}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="text-3xl font-bold text-black-600">
                                                        {/* {boardData.filter(board => board.selected).length} */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Total Grades Card */}
                                        <div className="col-4">
                                            <div className="bg-white border-round-lg shadow-2 p-4" style={{ width: '370px', height: '84px' }}>
                                                <div className="flex align-items-center justify-content-between">
                                                    <div className="flex align-items-center">
                                                        <div className=" border-round-md p-3 mr-3">
                                                            {/* <i className="pi pi-graduation-cap text-2xl text-green-600"></i> */}
                                                            <GradesIcon height={16.5} width={19.5} />

                                                        </div>
                                                        <div>
                                                            <h3 className="text-xl font-bold text-gray-800 m-0">Total Grades</h3>
                                                            <p className="text-gray-600 text-sm m-0 mt-1">
                                                                {gradeData.filter(grade => grade.selected).length} Grade{gradeData.filter(grade => grade.selected).length !== 1 ? 's' : ''}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="text-3xl font-bold text-green-600">
                                                        {/* {gradeData.filter(grade => grade.selected).length} */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Total Sections Card */}
                                        <div className="col-4">
                                            <div className="bg-white border-round-lg shadow-2 p-4" style={{ width: '370px', height: '84px' }}>
                                                <div className="flex align-items-center justify-content-between">
                                                    <div className="flex align-items-center">
                                                        <div className="border-round-md p-3 mr-3">
                                                            {/* <i className="pi pi-users text-2xl text-purple-600"></i> */}
                                                            <SectionIcon height={16.5} width={19.5} />

                                                        </div>
                                                        <div>
                                                            <h3 className="text-xl font-bold text-gray-800 m-0">Total Sections</h3>
                                                            <p className="text-gray-600 text-sm m-0 mt-1">
                                                                {sectionData.filter(section => section.selected).length} Section{sectionData.filter(section => section.selected).length !== 1 ? 's' : ''}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="text-3xl font-bold text-purple-600">
                                                        {/* {sectionData.filter(section => section.selected).length} */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                {/* Interactive Boards, Grades, and Sections Display */}
                                <div className="mt-4  ml-1 mr-4">
                                    <div className="col-12">
                                        {/* Board Cards */}
                                        <div className="grid">
                                            {boardData.filter(board => board.selected).length === 0 ? (
                                                <div className="col-12">
                                                    <div className="empty-state text-center p-4">
                                                        {/* <i className="pi pi-info-circle text-4xl text-400 mb-3"></i> */}
                                                        <p className="text-600">No boards selected for this branch</p>
                                                    </div>
                                                </div>
                                            ) : (
                                                boardData.filter(board => board.selected).map(board => {
                                                    // Get grades for this board
                                                    const boardGrades = gradeData.filter(grade =>
                                                        grade.selected && grade.boardId === board.boardId
                                                    );

                                                    return (
                                                        <div key={board.boardId} className="col-12 mb-4">
                                                            <Card className="shadow-3 border-round-lg overflow-hidden">
                                                                {/* Board Header */}
                                                                <div className="flex align-items-center justify-content-between surface-border">
                                                                    <div className="flex align-items-center">
                                                                        {/* <div className="bg-blue-500 border-round-md p-3 mr-3">
                                                                            <i className="pi pi-book text-xl text-white"></i>
                                                                        </div> */}
                                                                        <div>
                                                                            <h3 className="text-xl font-bold text-gray-800 " style={{ color: '#1E1E1E' }}>
                                                                                {board.boardName}
                                                                            </h3>
                                                                        </div>
                                                                    </div>
                                                                    {/* <div className="flex align-items-center">
                                                                        <i className="pi pi-check-circle text-green-500 text-2xl"></i>
                                                                    </div> */}
                                                                </div>

                                                                {/* Grades Content */}
                                                                <div className="">
                                                                    {boardGrades.length === 0 ? (
                                                                        <div className="text-center p-4">
                                                                            <i className="pi pi-info-circle text-3xl text-400 mb-1"></i>
                                                                            <p className="text-600">No grades selected for this board</p>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="grid gap-3">
                                                                            {boardGrades.map(grade => {
                                                                                // Get sections for this grade
                                                                                const gradeSections = sectionData.filter(section =>
                                                                                    section.selected && section.gradeId === grade.gradeId
                                                                                );

                                                                                return (
                                                                                    <div key={grade.gradeId} className="col-12">
                                                                                        <div className="bg-gray-50 border-round-lg p-4" style={{ backgroundColor: '#D9D9D9', height: '114px', minWidth: '240px', border: '2px solid #F5F5F5' }}>
                                                                                            {/* Grade Header */}
                                                                                            <div className="flex align-items-center justify-content-between mb-3">
                                                                                                <div className="flex align-items-center">
                                                                                                    {/* <div className="bg-green-100 border-round-md p-2 mr-3">
                                                                                                        <i className="pi pi-graduation-cap text-lg text-green-600"></i>
                                                                                                    </div> */}
                                                                                                    <div>
                                                                                                        <h4 className="text-lg font-semibold text-gray-800 m-0">
                                                                                                            {grade.gradeName}
                                                                                                        </h4>
                                                                                                        {/* <p className="text-sm text-gray-600 m-0">
                                                                                                            {gradeSections.length} Section{gradeSections.length !== 1 ? 's' : ''}
                                                                                                        </p> */}
                                                                                                    </div>
                                                                                                </div>
                                                                                                {/* <i className="pi pi-check-circle text-green-500 text-lg"></i> */}
                                                                                            </div>

                                                                                            {/* Sections */}
                                                                                            {gradeSections.length === 0 ? (
                                                                                                <div className="text-center p-3">
                                                                                                    <p className="text-600 text-sm">No sections selected for this grade</p>
                                                                                                </div>
                                                                                            ) : (
                                                                                                <div className="flex flex-wrap gap-2">
                                                                                                    {gradeSections.map(section => (
                                                                                                        <div
                                                                                                            key={section.sectionId}
                                                                                                            className=""
                                                                                                        >
                                                                                                            {/* <div className="bg-purple-100 border-round-circle p-1 mr-2" style={{ width: '20px', height: '20px' }}>
                                                                                                                <i className="pi pi-users text-xs text-purple-600"></i>
                                                                                                            </div> */}
                                                                                                            <span className="text-sm font-medium text-gray-800" style={{ backgroundColor: '#E6E8EA', height: '36px', width: '98px', borderRadius: '12px', gap: '8px', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                                                {section.sectionName}
                                                                                                            </span>
                                                                                                            {/* <span className="text-xs text-gray-500 ml-2">
                                                                                                                ({section.studentCount || 0} students)
                                                                                                            </span> */}
                                                                                                        </div>
                                                                                                    ))}
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </Card>
                                                        </div>
                                                    );
                                                })
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Conditionally render Fee Schedule Section */}
                                {moduleFlags.showFeeSchedule ? (
                                    <div className='mt-4 ml-4 mr-8'>
                                        <div className="flex align-items-center gap-2 mb-3">
                                            <h1 className='text-2xl font-bold text-black mb-2' style={{ color: 'black' }}>
                                                <u>Fee schedule</u>
                                            </h1>
                                            {/* <Badge value="Module Enabled" severity="success" /> */}
                                        </div>

                                        <DataTable
                                            value={scheduleInfo}
                                            dataKey="id"
                                            paginator
                                            lazy
                                            onPage={(event) => {
                                                this.setState({
                                                    lazyParams: { ...this.state.lazyParams, first: event.first, rows: event.rows }
                                                }, this.getFeeScheduleData);
                                            }}
                                            first={lazyParams.first}
                                            rows={lazyParams.rows}
                                            totalRecords={totalRecords}
                                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Fee Schedules"
                                            responsiveLayout="scroll"
                                            sortable
                                            emptyMessage="No fee schedules found for this branch"
                                        >
                                            <Column
                                                header="S.No."
                                                className="datatable-cel"
                                                body={(rowData, index) => (
                                                    <p>{index.rowIndex + 1}</p>
                                                )}
                                            />
                                            <Column field="scheduleName" header="Schedule Name" className="datatable-cel" sortable />
                                            <Column
                                                header="Plan / No Plan"
                                                className="datatable-cel"
                                                body={(rowData) => (
                                                    <p>{rowData?.planId ? "Plan" : "No Plan"}</p>
                                                )}
                                            />
                                            <Column
                                                className=""
                                                header="Preview"
                                                body={(rowData, { rowIndex }) => (
                                                    <div className="flex cursor-pointer">
                                                        <span
                                                            data-pr-tooltip="View Fee Schedule"
                                                            className={`ma-ml10 uy${rowIndex}`}
                                                            onClick={() => this.onEdit(rowData, true)}
                                                        >
                                                            <i className="pi pi-eye text-gray-500 cursor-pointer" style={{ fontSize: '1.2rem' }}></i>
                                                        </span>
                                                        <Tooltip target={`.uy${rowIndex}`} />
                                                    </div>
                                                )}
                                            />
                                        </DataTable>

                                        {/* <div className='mt-4'>
                                            <span style={{ color: 'red', fontWeight: 'bold' }}>Note: </span>
                                            All the Fee type, Fee plan, Fee structure along with due date will be promoted according to the selected academic year along with concessions bank accounts fines and finance general settings.
                                        </div> */}


                                    </div>
                                ) : (""
                                    // <div className='mt-4'>
                                    //     <div className="flex align-items-center gap-2 mb-3">
                                    //         <h1 className='text-2xl font-bold text-gray-400 mb-2'>
                                    //             <u>Fee schedule</u>
                                    //         </h1>
                                    //         <Badge value="Module Disabled" severity="danger" />
                                    //     </div>
                                    //     <div className="text-center p-4 bg-gray-50 border-radius-md">
                                    //         <i className="pi pi-info-circle text-4xl text-gray-400 mb-3"></i>
                                    //         <p className="text-gray-600 mb-2">Fee Setup module is not selected for this branch</p>
                                    //         <p className="text-sm text-gray-500">Fee schedules will not be promoted for this branch</p>
                                    //     </div>
                                    // </div>
                                )}

                                {/* Conditionally render Transport Section */}
                                {/* {moduleFlags.showTransport ? (
                        <div className='mt-4'>
                            <div className="flex align-items-center gap-2 mb-3">
                                <h1 className='text-2xl font-bold text-black mb-2' style={{ color: 'black' }}>
                                    <u>Transport</u>
                                </h1>
                                <Badge value="Module Enabled" severity="success" />
                            </div>

                            <div className="mt-4">
                                <div className="card datatable-crud-demo ma-m30">
                                    <DataTable
                                        className="dataTableValuesText"
                                        columnResizeMode="expand"
                                        value={transportRoutes}
                                        dataKey="_id"
                                        paginator
                                        responsiveLayout="scroll"
                                        totalRecords={transportRoutes?.length || 0}
                                        rows={10}
                                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Transport Routes"
                                        emptyMessage="No transport routes found for the selected branch"
                                    >
                                        <Column
                                            style={{ width: '15rem', height: '6rem' }}
                                            alignHeader={'center'}
                                            sortable
                                            headerClassName="text-color-secondary"
                                            bodyClassName="text-center"
                                            header="S.No."
                                            className="datatable-cell"
                                            body={(rowData, index) => (
                                                <p>{index.rowIndex + 1}</p>
                                            )}
                                        />

                                        <Column
                                            style={{ width: '15rem', height: '6rem' }}
                                            alignHeader={'center'}
                                            sortable
                                            headerClassName="text-color-secondary"
                                            bodyClassName="text-center"
                                            filterField="vehicleRegistrationNo"
                                            field="vehicleRegistrationNo"
                                            header="Registration No"
                                        />

                                        <Column
                                            style={{ width: '15rem', height: '6rem' }}
                                            alignHeader={'center'}
                                            sortable
                                            headerClassName="text-color-secondary"
                                            bodyClassName="text-center"
                                            filterField="routeName"
                                            field="routeName"
                                            header="Route Name"
                                        />

                                        <Column
                                            style={{ width: '15rem', height: '6rem' }}
                                            alignHeader={'center'}
                                            sortable
                                            headerClassName="text-color-secondary"
                                            bodyClassName="text-center"
                                            filterField="totalStops"
                                            field="totalStops"
                                            header="Total Stops"
                                        />

                                        <Column
                                            style={{ width: '15rem', height: '6rem' }}
                                            alignHeader={'center'}
                                            sortable
                                            headerClassName="text-color-secondary"
                                            bodyClassName="text-center"
                                            filterField="startLocation"
                                            field="startPoint"
                                            header="Start Location"
                                        />

                                        <Column
                                            style={{ width: '15rem', height: '6rem' }}
                                            alignHeader={'center'}
                                            sortable
                                            headerClassName="text-color-secondary"
                                            bodyClassName="text-center"
                                            filterField="endLocation"
                                            field="endPoint"
                                            header="End Location"
                                        />

                                        <Column
                                            alignHeader={'center'}
                                            bodyClassName="text-center"
                                            header="Status"
                                            body={(rowData) => (
                                                <Badge
                                                    value={rowData.isActive ? 'Active' : 'Inactive'}
                                                    severity={rowData.isActive ? 'success' : 'warning'}
                                                />
                                            )}
                                        />
                                    </DataTable>
                                </div>

                                <div className='mt-4'>
                                    <span style={{ color: 'red', fontWeight: 'bold' }}>Note: </span>
                                    Transport will be promoted according to the selected academic year as it is along with Transport settings, Transport Fees, transport staff.
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className='mt-4'>
                            <div className="flex align-items-center gap-2 mb-3">
                                <h1 className='text-2xl font-bold text-gray-400 mb-2'>
                                    <u>Transport</u>
                                </h1>
                                <Badge value="Module Disabled" severity="danger" />
                            </div>
                            <div className="text-center p-4 bg-gray-50 border-radius-md">
                                <i className="pi pi-info-circle text-4xl text-gray-400 mb-3"></i>
                                <p className="text-gray-600 mb-2">Transport module is not selected for this branch</p>
                                <p className="text-sm text-gray-500">Transport routes will not be promoted for this branch</p>
                            </div>
                        </div>
                    )} */}

                                {/* Show Admissions section if enabled */}
                                <div className='flex  lg:flex-row  mt-4 ml-4 mr-8 gap-5 button-module'>
                                    {moduleFlags.showAdmissions && (
                                        <div className='mt-4 bg-white p-4 border-1 border-gray-200 border-radius-md' style={{ minWidth: '240px', width: '440px', borderRadius: '8px' }}>
                                            <div className="flex align-items-center gap-2 mb-3" >
                                                <h1 className='text-2xl font-bold text-black mb-2' style={{ color: 'black' }}>
                                                    Admissions
                                                </h1>
                                            </div>
                                            <p className="text-gray-600 mb-3">Configure admission criteria, categories, and registration fees</p>

                                            {/* Admissions sub-sections */}
                                            <div className="flex gap-2 flex-wrap">

                                                <button className="bg-gray-100 text-gray-700 px-4 py-2 border-radius-md text-sm font-medium border-none cursor-pointer">
                                                    Age Criteria
                                                </button>
                                                <button className="bg-gray-100 text-gray-700 px-4 py-2 border-radius-md text-sm font-medium border-none cursor-pointer">
                                                    Admission Categories
                                                </button>
                                                <button className="bg-gray-100 text-gray-700 px-4 py-2 border-radius-md text-sm font-medium border-none cursor-pointer">
                                                    Registration Fees
                                                </button>
                                            </div>



                                        </div>
                                    )}
                                    {/* Show Finance General Settings section if enabled */}
                                    {moduleFlags.showFinanceGeneralSettings && (
                                        <div className='mt-4  bg-white p-4 border-1 border-gray-200 border-radius-md' style={{ minWidth: '240px', width: '440px', borderRadius: '8px' }}>
                                            <div className="flex align-items-center gap-2 mb-3">
                                                <h1 className='text-2xl font-bold text-black mb-2' style={{ color: 'black' }}>
                                                    Finance General Settings
                                                </h1>
                                            </div>
                                            <p className="text-gray-600 mb-3">Set up core financial configurations and parameters</p>

                                            {/* Finance General Settings sub-sections */}
                                            <div className="grid">
                                                <div className="col-6">
                                                    <div className="flex gap-2">
                                                        <button className="bg-gray-100 text-gray-700 px-4 py-2 border-radius-md text-sm font-medium border-none cursor-pointer">
                                                            {/* Fee Concession */}
                                                            General Settings
                                                        </button>
                                                        {/* <button className="bg-gray-100 text-gray-700 px-4 py-2 border-radius-md text-sm font-medium border-none cursor-pointer">
                                                Fine Management
                                            </button> */}
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    )}
                                    {/* Show Finance Operations section if enabled */}
                                    {moduleFlags.showFinance ? (
                                        <div className='mt-4  bg-white p-4 border-1 border-gray-200 border-radius-md' style={{ minWidth: '240px', width: '440px', borderRadius: '8px' }}>
                                            <div className="flex align-items-center gap-2 mb-3">
                                                <h1 className='text-2xl font-bold text-black mb-2' style={{ color: 'black' }}>
                                                    Finance
                                                </h1>
                                            </div>
                                            <p className="text-gray-600 mb-3">Manage fee concessions, fines, and payment processing</p>

                                            {/* Finance Operations sub-sections */}
                                            <div className="flex gap-2">
                                                <button className="bg-gray-100 text-gray-700 px-4 py-2 border-radius-md text-sm font-medium border-none cursor-pointer">
                                                    Fee Concession
                                                </button>
                                                <button className="bg-gray-100 text-gray-700 px-4 py-2 border-radius-md text-sm font-medium border-none cursor-pointer">
                                                    Fine Management
                                                </button>
                                            </div>
                                        </div>
                                    ) : (""
                                        // <div className='mt-4'>
                                        //     <div className="flex align-items-center gap-2 mb-3">
                                        //         <h1 className='text-2xl font-bold text-gray-400 mb-2'>
                                        //             <u>Finance</u>
                                        //         </h1>
                                        //         <Badge value="Module Disabled" severity="danger" />
                                        //     </div>
                                        //     <div className="text-center p-4 bg-gray-50 border-radius-md">
                                        //         <i className="pi pi-info-circle text-4xl text-gray-400 mb-3"></i>
                                        //         <p className="text-gray-600 mb-2">Finance module is not selected for this branch</p>
                                        //         <p className="text-sm text-gray-500">Finance data will not be promoted for this branch</p>
                                        //     </div>
                                        // </div>
                                    )}
                                </div>

                            </Card>

                            {/* close button to close the specific opened branch */}
                            <div className="flex justify-content-center mt-4 mb-4">
                                <Button
                                    label="Close"
                                    // icon="pi pi-times"
                                    className="p-button-outlined"
                                    style={{
                                        borderRadius: '12px',
                                        padding: '12px 24px',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        border: '2px solid #E5E7EB',
                                        color: 'white',
                                        backgroundColor: '#076EFF',
                                        width: '201px',
                                        height: '48px'
                                    }}
                                    onClick={() => this.setState({
                                        expandedBranchId: null,
                                        branchCardsVisible: true
                                    })}
                                />
                            </div>

                            {/* Fee Schedule Create Dialog */}
                            <Dialog
                                header="Create Fee Schedule"
                                visible={openCreateFeeScheduleDialog}
                                style={{ width: '80vw', height: '90vh' }}
                                onHide={this.onHideCreateFeeScheduleDialog}
                                maximizable
                            >
                                <div className="p-4">
                                    {/* Fee Plan Toggle */}
                                    <div className="mb-4">
                                        <div className="flex align-items-center gap-2 mb-2">
                                            <ToggleButton
                                                checked={isFeePlanBased}
                                                onChange={() => {
                                                    this.setState({
                                                        isFeePlanBased: !isFeePlanBased
                                                    }, () => {
                                                        !isFeePlanBased && this.getFeeTypes();
                                                    });
                                                }}
                                                onLabel="Using Fee Plan"
                                                offLabel="Using Custom Fee Types"
                                                style={{
                                                    height: '48px',
                                                    fontWeight: 500,
                                                    borderRadius: '8px'
                                                }}
                                            />
                                            <small className="block text-gray-600">
                                                {isFeePlanBased
                                                    ? "Currently using pre-defined fee plan. Click to switch to custom fee types."
                                                    : "Currently using custom fee types. Click to switch to pre-defined fee plan."}
                                            </small>
                                        </div>
                                    </div>

                                    {/* Form Fields based on Fee Plan Selection */}
                                    {isFeePlanBased ? (
                                        <div className="grid">
                                            <div className="col-4">
                                                <label className="label">
                                                    Schedule Name<span className="ma-required">*</span>
                                                </label>
                                                <div className="mt-2">
                                                    <ClassetInputText
                                                        className=""
                                                        height="48px"
                                                        width="100%"
                                                        placeholder="Schedule Name"
                                                        value={scheduleName}
                                                        onChange={(e) => this.setState({ scheduleName: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <label className="label">
                                                    Fee Structure<span className="ma-required">*</span>
                                                </label>
                                                <div className="mt-2">
                                                    <ClassetDropdown
                                                        optionLabel="structureName"
                                                        optionValue="_id"
                                                        width="w-full"
                                                        value={selectedFeeStructure?._id}
                                                        options={feeStructureInfo}
                                                        onChange={this.handleFeeStructureChange}
                                                        placeholder="Select Fee Structure"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <label className="label">
                                                    Fee Plan<span className="ma-required">*</span>
                                                </label>
                                                <div className="mt-2">
                                                    <ClassetDropdown
                                                        disabled={!selectedFeeStructure}
                                                        optionLabel="planName"
                                                        optionValue="_id"
                                                        width="w-full"
                                                        value={selectedFeePlan?._id}
                                                        options={plansData}
                                                        onChange={this.handleFeePlanChange}
                                                        placeholder="Select Fee Plan"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="grid">
                                            <div className="col-6">
                                                <label className="label">
                                                    Schedule Name<span className="ma-required">*</span>
                                                </label>
                                                <div className="mt-2">
                                                    <ClassetInputText
                                                        className=""
                                                        height="48px"
                                                        width="368px"
                                                        placeholder="Schedule Name"
                                                        value={scheduleName}
                                                        onChange={(e) => this.setState({ scheduleName: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <label className="label">
                                                    Fee Types<span className="ma-required">*</span>
                                                </label>
                                                <div className="mt-2">
                                                    <ClassetMultiSelect
                                                        id="feeTypes"
                                                        className=""
                                                        height="48px"
                                                        width="368px"
                                                        options={this.state.originalFeeTypes}
                                                        optionValue="_id"
                                                        optionLabel="feeType"
                                                        value={this.state.selectedFeeTypes}
                                                        onChange={this.handleFeeTypeSelection}
                                                        placeholder="Select Fee Types"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Installment Data Display */}
                                    {isFeePlanBased && selectedFeePlan && selectedFeeStructure && (
                                        <div className="mt-4">
                                            {/* One-time fees section */}
                                            {oneTimeFees?.length > 0 && (
                                                <div className="mb-4">
                                                    <h4 className="text-xl font-semibold mb-2">One Time Fees</h4>
                                                    <DataTable value={oneTimeFees} responsiveLayout="scroll">
                                                        <Column field="feeType" header="Fee Type" />
                                                        <Column field="totalFee" header="Total Fee" />
                                                        <Column
                                                            header="Due Date"
                                                            body={(rowData) => (
                                                                <ClassetCalendar
                                                                    className="border-calendar"
                                                                    width={'280px'}
                                                                    height={'48px'}
                                                                    inputClassName="font-semibold"
                                                                    calendarMode={'single'}
                                                                    value={rowData.dueDate}
                                                                    placeholder="Select Due Date"
                                                                    yearNavigator
                                                                    yearRange="2000:2050"
                                                                />
                                                            )}
                                                        />
                                                    </DataTable>
                                                </div>
                                            )}

                                            {/* Regular installments */}
                                            {installmentData?.map((installment, installmentIndex) => {
                                                const planInstallment = selectedFeePlan?.installments?.find(
                                                    i => i.installmentId === installment.installmentId
                                                );

                                                return (
                                                    <div key={installmentIndex} className="mb-4">
                                                        <div className="flex align-items-center gap-3 mb-2">
                                                            <h4 className="m-0">
                                                                {installment.installment} - {planInstallment ? moment(planInstallment.date).format('DD/MM/YYYY') : 'Date not set'}
                                                            </h4>
                                                        </div>
                                                        <DataTable value={installment.feeTypes} responsiveLayout="scroll">
                                                            <Column field="feeType" header="Fee Type" />
                                                            <Column field="totalFee" header="Total Fee" />
                                                            <Column
                                                                header="Percentage"
                                                                body={(rowData) => (
                                                                    <ClassetInputText
                                                                        value={rowData.percentage || 0}
                                                                        onChange={(e) => this.handlePercentageChange(e, installmentIndex, rowData)}
                                                                        placeholder="Percentage"
                                                                        keyfilter="num"
                                                                        min={0}
                                                                        max={100}
                                                                        className="p-inputtext-sm"
                                                                        style={{ width: '100px' }}
                                                                    />
                                                                )}
                                                            />
                                                            <Column
                                                                header="Calculated Fee"
                                                                body={(rowData) => (
                                                                    <ClassetInputText
                                                                        value={rowData.calculatedFee || 0}
                                                                        placeholder="Calculated Fee"
                                                                        disabled={rowData?.isTransportFeeType}
                                                                        keyfilter="num"
                                                                        min={0}
                                                                        max={rowData.totalFee}
                                                                        className="p-inputtext-sm"
                                                                        style={{ width: '100px' }}
                                                                    />
                                                                )}
                                                            />
                                                        </DataTable>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}

                                    <div className="flex justify-content-center mb-4 mt-4 p-2">
                                        <Button
                                            label="Save"
                                            className="p-button-primary submitButtonn mr-4 button text-lg"
                                            onClick={() => {
                                                // Add save logic here
                                                this.showSuccess('Fee schedule saved successfully!');
                                                this.onHideCreateFeeScheduleDialog();
                                            }}
                                        />
                                        {/* <Button
                                            label="Cancel"
                                            className="p-button-outlined submitButtonn button text-lg"
                                            onClick={this.onHideCreateFeeScheduleDialog}
                                        /> */}
                                    </div>
                                </div>
                            </Dialog>

                            {/* Fee Schedule View Dialog */}
                            <Dialog
                                header="View Fee Schedule"
                                visible={openViewFeeScheduleDialog}
                                style={{ width: '80vw', height: '90vh' }}
                                onHide={this.onHideViewFeeScheduleDialog}
                                maximizable
                            >
                                <div className="p-4">
                                    {/* Read-only Schedule Information */}
                                    <div className="grid mb-4">
                                        <div className="col-4">
                                            <label className="label font-semibold">Schedule Name</label>
                                            <div className="mt-2 p-2 bg-gray-50 border-radius-md">
                                                {viewFeeSchedule.scheduleName}
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <label className="label font-semibold">Plan Type</label>
                                            <div className="mt-2 p-2 bg-gray-50 border-radius-md">
                                                {viewFeeSchedule?.planId ? "Plan Based" : "Custom Fee Types"}
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <label className="label font-semibold">Status</label>
                                            <div className="mt-2">
                                                <Badge
                                                    value={viewFeeSchedule.isActive ? 'Active' : 'Inactive'}
                                                    severity={viewFeeSchedule.isActive ? 'success' : 'warning'}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Display Fee Structure Information */}
                                    {selectedFeeStructure && (
                                        <div className="mb-4">
                                            <h4 className="text-xl font-semibold mb-2">Fee Structure: {selectedFeeStructure.structureName || 'N/A'}</h4>
                                            {selectedFeePlan && (
                                                <p className="text-gray-600">Fee Plan: {selectedFeePlan.planName}</p>
                                            )}
                                        </div>
                                    )}

                                    {/* One-time fees section - Read Only */}
                                    {oneTimeFees?.length > 0 && (
                                        <div className="mb-4">
                                            <h4 className="text-xl font-semibold mb-2">One Time Fees</h4>
                                            <DataTable value={oneTimeFees} responsiveLayout="scroll">
                                                <Column field="feeType" header="Fee Type" />
                                                <Column
                                                    field="totalFee"
                                                    header="Total Fee"
                                                    body={(rowData) => `₹${rowData.totalFee || 0}`}
                                                />
                                                <Column
                                                    header="Due Date"
                                                    body={(rowData) => (
                                                        <span>{moment(rowData.dueDate).format('DD/MM/YYYY')}</span>
                                                    )}
                                                />
                                            </DataTable>
                                        </div>
                                    )}

                                    {/* Regular installments - Read Only */}
                                    {installmentData?.map((installment, installmentIndex) => {
                                        const planInstallment = selectedFeePlan?.installments?.find(
                                            i => i.installmentId === installment.installmentId
                                        );

                                        return (
                                            <div key={installmentIndex} className="mb-4">
                                                <div className="flex align-items-center gap-3 mb-2">
                                                    <h4 className="m-0">
                                                        {installment.installment} - {planInstallment ? moment(planInstallment.date).format('DD/MM/YYYY') : 'Date not set'}
                                                    </h4>
                                                </div>
                                                <DataTable value={installment.feeTypes} responsiveLayout="scroll">
                                                    <Column field="feeType" header="Fee Type" />
                                                    <Column
                                                        field="totalFee"
                                                        header="Total Fee"
                                                        body={(rowData) => `₹${rowData.totalFee || 0}`}
                                                    />
                                                    <Column
                                                        header="Percentage"
                                                        body={(rowData) => `${rowData.percentage || 0}%`}
                                                    />
                                                    <Column
                                                        header="Calculated Fee"
                                                        body={(rowData) => `₹${rowData.calculatedFee || 0}`}
                                                    />
                                                </DataTable>
                                            </div>
                                        );
                                    })}

                                    <div className="flex justify-content-center mb-4 mt-4 p-2">
                                        <Button
                                            label="Close"
                                            className="p-button-outlined submitButtonn button text-lg"
                                            onClick={this.onHideViewFeeScheduleDialog}
                                        />
                                    </div>
                                </div>
                            </Dialog>

                            {/* Action Buttons */}
                            <div className="promotion-footer flex justify-content-center gap-3">
                                {/* <Button
                                    label="Cancel"
                                    icon="pi pi-times"
                                    className="p-button-outlined promotion-cancel-btn"
                                    style={{
                                        borderRadius: '12px',
                                        padding: '12px 24px',
                                        fontSize: '16px',
                                        fontWeight: '600',
                                        color: '#6B7280',
                                        backgroundColor: '#F4F5F6',
                                        width: '150px',
                                        height: '48px'
                                    }}
                                    onClick={this.handleCancel}
                                    disabled={isLoading}
                                /> */}
                                {/* <Button
                                    label="Back"
                                    icon="pi pi-arrow-left"
                                    className="p-button-outlined promotion-cancel-btn"
                                    style={{
                                        borderRadius: '12px',
                                        padding: '12px 24px',
                                        fontSize: '16px',
                                        fontWeight: '600',
                                        color: '#6B7280',
                                        backgroundColor: '#F4F5F6',
                                        width: '150px',
                                        height: '48px'
                                    }}
                                    onClick={this.handleBack}
                                    disabled={isLoading}
                                /> */}
                                {/* {!isFirstBranch && (
                                    <Button
                                        label="Previous Branch"
                                        icon="pi pi-chevron-left"
                                        className="p-button-outlined promotion-cancel-btn"
                                        style={{
                                            borderRadius: '12px',
                                            padding: '12px 24px',
                                            fontSize: '16px',
                                            fontWeight: '600',
                                            color: '#6B7280',
                                            backgroundColor: '#F4F5F6',
                                            width: '170px',
                                            height: '48px'
                                        }}
                                        onClick={this.handlePrevious}
                                        disabled={isLoading}
                                    />
                                )} */}
                                {/* {!isLastBranch ? (
                                    <Button
                                        label="Next Branch"
                                        icon="pi pi-chevron-right"
                                        iconPos="right"
                                        className="p-button promotion-next-btn"
                                        style={{
                                            borderRadius: '12px',
                                            padding: '12px 24px',
                                            fontSize: '16px',
                                            fontWeight: '600',
                                            backgroundColor: !isLoading ? '#3B82F6' : '#9CA3AF',
                                            border: 'none',
                                            color: '#ffffff',
                                            width: '170px',
                                            height: '48px',
                                            cursor: !isLoading ? 'pointer' : 'not-allowed',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onClick={this.handleNext}
                                        disabled={isLoading}
                                    />
                                ) : (""
                                    // <Button
                                    //     label={isLoading ? "Promoting..." : "Promote"}
                                    //     icon={isLoading ? "pi pi-spin pi-spinner" : "pi pi-check"}
                                    //     iconPos="right"
                                    //     className="p-button promotion-next-btn"
                                    //     style={{
                                    //         borderRadius: '12px',
                                    //         padding: '12px 24px',
                                    //         fontSize: '16px',
                                    //         fontWeight: '600',
                                    //         backgroundColor: !isLoading ? '#3B82F6' : '#9CA3AF',
                                    //         border: 'none',
                                    //         color: '#ffffff',
                                    //         width: '150px',
                                    //         height: '48px',
                                    //         cursor: !isLoading ? 'pointer' : 'not-allowed',
                                    //         transition: 'all 0.3s ease'
                                    //     }}
                                    //     onClick={this.handleSubmit}
                                    //     disabled={isLoading}
                                    // />
                                )} */}
                            </div>
                        </>
                    )}
                </div>

                {/* Action Buttons - Only show when a branch is expanded */}
                {expandedBranchId && (
                    <div className="flex justify-content-center gap-3">
                        {/* <Button
                            label="Cancel"
                            icon="pi pi-times"
                            className="p-button-outlined"
                            style={{
                                borderRadius: '8px',
                                padding: '12px 24px',
                                fontSize: '14px',
                                fontWeight: '600',
                                color: '#6B7280',
                                backgroundColor: '#F4F5F6',
                                minWidth: '100px'
                            }}
                            onClick={this.handleCancel}
                            disabled={isLoading}
                        /> */}
                        {/* <Button
                            label="Back"
                            icon="pi pi-arrow-left"
                            className="promotion-cancel-btn"
                            style={{
                                borderRadius: '12px',
                                height: '48px',
                                width: '150px',
                                backgroundColor: '#F4F5F6',
                                color: '#6B7280',
                                fontWeight: '500'
                            }}
                            onClick={this.handleBack}
                            disabled={isLoading}
                        /> */}
                        {/* {!isFirstBranch && (
                            <Button
                                label="Previous Branch"
                                icon="pi pi-chevron-left"
                                className="promotion-cancel-btn"
                                style={{
                                    borderRadius: '12px',
                                    height: '48px',
                                    width: '150px',
                                    backgroundColor: '#F4F5F6',
                                    color: '#6B7280',
                                    fontWeight: '500'
                                }}
                                onClick={this.handlePrevious}
                                disabled={isLoading}
                            />
                        )} */}
                        {/* {!isLastBranch ? (
                            <Button
                                label="Next Branch"
                                icon="pi pi-chevron-right"
                                iconPos="right"
                                className="promotion-next-btn"
                                style={{
                                    borderRadius: '12px',
                                    height: '48px',
                                    width: '150px',
                                    backgroundColor: '#3B82F6',
                                    border: '1px solid #3B82F6',
                                    color: 'white',
                                    fontWeight: '500'
                                }}
                                onClick={this.handleNext}
                                disabled={isLoading}
                            />
                        ) : (""
                            // <Button
                            //     label={isLoading ? "Promoting..." : "Promote"}
                            //     icon={isLoading ? "pi pi-spin pi-spinner" : "pi pi-check"}
                            //     iconPos="right"
                            //     className="promotion-next-btn"
                            //     style={{
                            //         borderRadius: '12px',
                            //         height: '48px',
                            //         width: '150px',
                            //         backgroundColor: '#3B82F6',
                            //         border: '1px solid #3B82F6',
                            //         color: 'white',
                            //         fontWeight: '500'
                            //     }}
                            //     onClick={this.isLastBranch ? this.handlePromote : this.handleNext}
                            //     disabled={isLoading}
                            // />
                        )} */}
                    </div>
                )}

                {/* Promotion Confirmation Dialog */}
                <Dialog
                    header="Confirm Promotion"
                    visible={showPromotionConfirmation}
                    style={{ width: '800px', borderRadius: '12px' }}
                    onHide={this.handleCancelPromotion}
                    footer={
                        <div className="flex justify-content-center gap-2">
                            <Button
                                label={isLoading ? "Promoting..." : "Confirm Promotion"}
                                // className="p-button-primary"
                                style={{
                                    borderRadius: '12px',
                                    padding: '12px 24px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    backgroundColor: !isLoading ? '#3B82F6' : '#9CA3AF',
                                    color: '#ffffff',
                                    width: '286px',
                                    height: '48px',
                                    cursor: !isLoading ? 'pointer' : 'not-allowed',
                                    transition: 'all 0.3s ease'
                                }}
                                onClick={this.handleConfirmPromotion}
                                disabled={isLoading}
                                loading={isLoading}
                            />
                            <Button
                                label="Cancel"
                                className="p-button-text"
                                onClick={this.handleCancelPromotion}
                                disabled={isLoading}
                                style={{
                                    borderRadius: '12px',
                                    padding: '12px 24px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    // border: '2px solid #E5E7EB',
                                    border: '0px solid black',

                                    color: '#6B7280',
                                    backgroundColor: '#F4F5F6',
                                    width: '150px',
                                    height: '48px'
                                }}
                            />

                        </div>
                    }
                >
                    <div className="flex align-items-center gap-3 mb-3">
                        <i className="pi pi-exclamation-triangle text-orange-500" style={{ fontSize: '2rem' }}></i>
                        <div>
                            <h4 className="m-0 mb-2">Promote All ?</h4>
                            <p className="m-0 text-600">
                                You are about to promote all selected branches to the target academic year.
                                This action will promote all data and cannot be undone.
                            </p>
                        </div>
                    </div>

                    {selectedBranches && selectedBranches.length > 0 && (
                        <div className="mt-3">
                            {/* <p className="font-semibold text-900 mb-2">
                                Branches to be promoted ({selectedBranches.length}):
                            </p> */}
                            {/* <ul className="list-none p-0 m-0">
                                {selectedBranches.map((branch, index) => (
                                    <li key={index} className="flex align-items-center gap-2 py-1">
                                        <i className="pi pi-check-circle text-green-500"></i>
                                        <span>{branch.branchName}</span>
                                    </li>
                                ))}
                            </ul> */}
                        </div>
                    )}

                    <div className="mt-4 p-3 bg-yellow-50 border-round">
                        <p className="m-0 text-sm text-orange-800">
                            <i className="pi pi-info-circle mr-2"></i>
                            <strong>Important:</strong> This promotion process may take several minutes to complete.
                            Please do not close this window during the process.
                        </p>
                    </div>
                </Dialog>

                {/* Loading Overlay */}
                {/* {isLoading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10000, // Higher than toast
                        backdropFilter: 'blur(2px)'
                    }}>
                        {promotionSuccess ? (
                            // Success State
                            <>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '80px',
                                    height: '80px',
                                    borderRadius: '50%',
                                    backgroundColor: '#10B981',
                                    marginBottom: '20px',
                                    animation: 'pulse 2s infinite'
                                }}>
                                    <i className="pi pi-check" style={{
                                        fontSize: '36px',
                                        color: 'white',
                                        fontWeight: 'bold'
                                    }}></i>
                                </div>
                                <h2 style={{
                                    fontSize: '24px',
                                    fontWeight: '700',
                                    color: '#10B981',
                                    margin: '0 0 10px 0',
                                    textAlign: 'center'
                                }}>
                                    🎉 Promotion Successful!
                                </h2>
                                <p style={{
                                    fontSize: '16px',
                                    fontWeight: '500',
                                    color: '#374151',
                                    margin: '0 0 16px 0',
                                    textAlign: 'center',
                                    maxWidth: '400px'
                                }}>
                                    {successMessage}
                                </p>
                                <p style={{
                                    fontSize: '14px',
                                    fontWeight: '400',
                                    color: '#6B7280',
                                    margin: 0,
                                    textAlign: 'center'
                                }}>
                                    Redirecting to home page...
                                </p>
                            </>
                        ) : (
                            // Loading State
                            <>
                                <ProgressSpinner
                                    style={{
                                        width: '60px',
                                        height: '60px',
                                        marginBottom: '20px'
                                    }}
                                    strokeWidth="4"
                                    fill="transparent"
                                    animationDuration=".8s"
                                />
                                <p style={{
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    color: '#374151',
                                    margin: 0,
                                    textAlign: 'center'
                                }}>
                                    Processing promotion...
                                </p>
                                <p style={{
                                    fontSize: '14px',
                                    fontWeight: '400',
                                    color: '#6B7280',
                                    margin: '8px 0 0 0',
                                    textAlign: 'center'
                                }}>
                                    Please wait, this may take a few minutes
                                </p>
                            </>
                        )}
                    </div>
                )} */}

            </div>

        );
    }
}

const mapStateToProps = (state) => ({
    isLoading: state.boardsData?.loading,
    isBranchLoading: state.branchDataLatest?.isLoading,
    branchData:
        (state.branchDataLatest &&
            state.branchDataLatest.data &&
            state.branchDataLatest.data.data?.filter((each) => {
                if (each.level === 1) {
                    return { ...each };
                }
            })) ||
        []
});


export default connect(mapStateToProps, {
    getBranchesLatest
})(PromotionPreview);